export default __webpack_public_path__ + "/src/assets/images/ic-modal-title-create-one-account.svg";